import { render, staticRenderFns } from "./CreateTeamDefinitionPopup.vue?vue&type=template&id=33e9f436&"
import script from "./CreateTeamDefinitionPopup.vue?vue&type=script&lang=js&"
export * from "./CreateTeamDefinitionPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports